import { WithFormControl } from "components/UI/Table/UI/InteractiveCell/miscs/types.ts";
import { FieldValues } from "react-hook-form";

export const isWithFormControl = <T extends FieldValues>(
    formControl: object | undefined
): formControl is WithFormControl<T>["formControl"] => {
    return (
        typeof formControl !== "undefined" &&
        "control" in formControl &&
        "name" in formControl &&
        typeof formControl.control === "object" &&
        typeof formControl.name === "string"
    );
};
